import axios from 'axios'
const INTERNAL_EMAIL_API = "kfa98anDa90naedaSDw9j"

const URI = "https://europe-west1-maakler-178918.cloudfunctions.net/cf-mailgun-center"
//const URI = "http://localhost:8080"

export const sendEmail = (email) => {
    return new Promise((resolve, reject) => {
        var data = {
            email:email,
            apiKey: INTERNAL_EMAIL_API
        }
        axios.post(URI+"/send", data)
          .then(resp => {
            if(resp.data) {
              resolve(resp.data)
            }
            else reject("no response")
          })
          .catch(err => {
            console.log('mailgunService > err:', err);
            
            reject(err)
          })
    })
}

export const addLead = (lead) => {
  return new Promise((resolve, reject) => {
      var data = {
          lead:lead,
          apiKey: INTERNAL_EMAIL_API
      }
      axios.post(URI+"/leads", data)
        .then(resp => {
          if(resp.data) {
            resolve(resp.data)
          }
          else reject("no response")
        })
        .catch(err => {
          console.log("err:", err)
          reject(err)
        })
  })
}


// WEBPACK FOOTER //
// ./src/third-party/mailgun/services/mailgunService.js